module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter Two")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("C")])])])]), _vm._v("onnell met the breathless boy halfway to the trading post.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She die, mister?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. Fainted. Where’s Mrs. Morse?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She ain’t comin’. I told her what you said but she didn’t believe me.” He trotted alongside, struggling to keep up with Connell’s long, purposeful strides. “Kin I have my penny, anyhows?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell muttered under his breath. No telling what had happened to the coin. Chances were he’d dropped it when he’d had to catch the girl.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He glanced down at the eager child. “Look in the dirt, where we were before. If it’s not there, follow along and I’ll get you another. And bring my horse. His name is Rojo. That’s Mexican for red. Call him by name and he won’t give you any grief. He’s a full-blooded canelo I picked up in California and I’d hate to lose him. I’d never find another one like him out here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Aw, shucks. You said…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell was in no mood for argument. “Go, before somebody else finds your money.” The boy seemed to see the logic in that suggestion, because he took off like a long-eared jackrabbit running from a pack of coyotes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Crossing to the trading post, Connell and his frail burden solicited few inquisitive glances. He looked down at the sweet face of the girl. Her cheeks were smudged and her hair nearly undone. The bonnet hung loosely by its ribbons. Her doe eyes were closed, but he could still picture them clearly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She stirred. Long, dark lashes fluttered against her fair skin like feathers on the breeze. She was so lovely, so innocent looking, lying there, the sight of her made his heart thump worse than the time he’d fought with Fremont against the Mexicans in San Jose in ’45.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The quick lurch of his gut took him totally by surprise. He stared down at the girl. She was all-fired young. Much younger than Irene. Couldn’t be more than eighteen or nineteen if she was a day. That made her ten or so years younger than he was; about the same distance apart in age as his mother and father had been.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Clenching his jaw, he tried unsuccessfully to set aside the bitter memories of his childhood, the mental image of his mother’s funeral and the cruel way his father had behaved afterward. If it hadn’t been for Irene and her family taking him in and showing him what a loving home was supposed to be like, no telling what would have become of him back then.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell took a deep breath and started across the street, his purpose redefined, his goal once again in focus. It didn’t matter how attracted he might be to this woman. Or to any other. It was Irene he had to think about, Irene he had sworn to find. To marry. If he had to spend the rest of his life looking for the truest friend he had ever had, then he would. Without ceasing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The unconscious girl moaned as Connell mounted the walkway in front of the trading post. Several Indians edged out of his path.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he made his way into the store, all conversation ceased. He headed straight for the proprietress.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anna Morse clapped a hand to her chest. “Land sakes! The boy was tellin’ the truth.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Obviously.” The plainsman reached her in six quick strides, his tall cavalry boots thumping hollowly on the floor. “Where can I put her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let’s take her upstairs,” Anna said. “Her sister’s right over…” Pointing, she snorted derisively. Charity had fainted dead away. The girl lay draped across a stack of flour sacks while two other women and a child patted her hands and fanned her cheeks. “Never mind. We’ll see to her, later. Bring Miss Faith this way.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Faith.")])]), _vm._v(" Connell turned that name over in his mind. He’d have guessed she might be called after a flower or some famous woman from the Bible, like Sarah or Esther. Hearing that she was, instead, Faith, gave him pause. Yet it fit. A strong trait, a gift necessary for survival especially when crossing the plains, Faith was appropriate. How was it the scripture went? Something about…“if you have faith as a grain of mustard seed, you can say to a mountain, move, and the mountain will move.” This tiny woman was going to need that kind of unwavering faith if she was to survive the many rigors that would face her on the trail.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The upstairs room Anna led him to was small but clean. An absence of personal items led Connell to believe Mrs. Morse probably rented it out whenever she could. Careful not to jostle his limp burden, he lowered Faith gently onto the bed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he straightened and slipped his arm from beneath her shoulders, he reached up to gently smooth the damp wisps of hair from her forehead. The act was totally instinctive. Until the older woman cautioned him, he didn’t think about how improper his actions must look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’ll do, mister. We’re beholden to you for totin’ her here.” Anna wedged between him and the prone figure, which was beginning to stir. “I’ll take good care of her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell nodded and touched the brim of his hat. “Yes, ma’am. It doesn’t appear the sister’ll be much help, that’s a fact.” Keeping his voice low, he added, “This one got herself knocked down by a bunch of drunken horse soldiers.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Figures. I swan, this old world has got to be nearin’ judgment day.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t know about that, ma’am, but there’s four boys in blue who will be when I get ahold of them.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You ain’t plannin’ on startin’ trouble, are you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, ma’am.” Connell took a few backward steps toward the open bedroom door. “Finishing it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anna made a noise of disgust. “Bah! All men are fools. Every bloomin’ one of ’em.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At that, the plainsman managed a half smile. “You’re probably right.” Peering past her, he tried to get another glimpse of Faith. “You think she’ll be all right? I reckon her ribs are broke.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Soon as she comes to, I’ll be able to tell for sure.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Turning toward the door, Connell paused. “I’ll be back to pay you for whatever the girl needs.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The older woman shook her head. “You ain’t her kin. You done enough.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He scowled, his helpful attitude hardening into determination. “I told you why I was here. Whatever I do for Miss Faith, it’ll be like I’m doing it for my Irene, too. Understand?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anna nodded solemnly. She wiped her hands on her apron. “That, I do. Long as you remember your money buys you no rights to the Beal sisters.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The growing smile lifted Connell’s mustache. “Oh, it won’t be my money,” he said. “I aim to collect damages due from the sons o’—’scuse me, I mean the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("soldiers")])]), _vm._v(" who did the hurting.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That seemed to satisfy Anna’s sense of decency. “Good for you. Think they’ll pay up?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For Connell, the question was already answered. His decision was firm. It wouldn’t take but a few minutes of his time to enforce justice on Faith Beal’s behalf. To see to it that she was recompensed. He was certain that was what Irene would want him to do.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, ma’am, I do,” he said flatly. “Those four boys’ll be real tickled to help out. You’ll see.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anna shook her head. “I don’t want to see any of it. You do what your conscience tells you to do, son, but leave me out of it. You hear?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tipping his hat, Connell nodded in affirmation and left her. By the time he’d reached the bottom of the staircase, his anger in respect to Faith’s plight was white-hot. How dare those drunken fools abuse a refined, gentle soul like her and then ignore what they’d done without so much as a backward glance or a word of apology?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He left the trading post, jumped down to the street and started off toward the saloon. Very little time had passed since the incident. He had no doubt he’d easily be able to locate the perpetrators.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The door to Maguire’s Saloon swung back with a bang as he straight-armed it and headed for the bar. The place wasn’t fancy red velvet and sparkling chandeliers like the plush parlors of San Francisco. Nor was it any cleaner than the rest of the fort. At each end of the bar stood gaboons, wooden boxes filled with sawdust, that served as poor men’s spittoons. By the look of the floor, no one there took very good aim.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell scanned the crowd. Nearly a dozen men were dressed in the blue of the cavalry but only a few were as filthy and bruised as the guilty parties he was looking for had to be. Bellying up to the bar, the largest of the four was lifting a glass and laughing as another member of the disgusting quartet gave his impression of Faith’s shocked facial expression after her fall.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Silent, Connell approached, his jaw set, his fists clenched. The loudmouth had reddish hair and a swollen eye as purple as a ripe plum. When Connell tapped him on the shoulder, he turned, still chuckling, with a sarcastic what-do-you-want? look on his face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell reached up and whipped off the man’s hat, turning it over to serve as a collection basket.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey! What the…?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“For the lady you boys hurt,” Connell said. The low, menacing timbre of his voice was as threatening as his words. “Ante up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The man cursed. “Now wait a…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell had grasped the redhead by the shirtfront and hoisted him high in the air before anyone could interfere. As formidable as the soldier was, he was no match for such ferocious rage and brute strength. The others began to edge away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All of you,” Connell shouted. “Freeze where you are and fill the kitty.” His head cocked toward the hat, which had landed on the bar when he’d grabbed the loudmouth. “Now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He waited till three soldiers had complied before releasing the fourth. “Your turn.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I ain’t got no money to waste on no stupid settler.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell’s fist connected hard with the man’s jaw, sending his body sliding along the front of the bar where it finally came to rest in a heap near the gaboon. He gestured to the man’s friends. “Pick him up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The smallest of the three shook his head violently and backed away, his hands in the air. Thin and much shorter than the others, he’d obviously gotten the worst of the brawl. “No way. He wakes up, he’ll kill me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Judging from what’s left of your sorry face, it looks like he nearly did, already.” Connell glanced at the remaining two. “You think your friend would be interested in making his fair share of the contribution?” He held out the hat. The few coins it contained chinked together.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure, sure. Ol’ Bob, he’s a regular fella. He just gets nasty when he’s keepin’ company with John Barleycorn, is all.” The closest one reached into his companion’s pockets and came up with a fistful of coins. “This do ya?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When the soldier dropped the money into the hat, Connell gathered it in his hand, briefly calculated how much there was, then threw the empty hat across the face of its unconscious owner. “He wakes up, you tell him for me that the lady is much obliged.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, sir. Sure will.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Turning away, Connell stalked out. He was certain neither Miss Faith Beal nor Mrs. Morse would approve of his methods, yet they’d have had to admit they were effective. There was no need to go into detail when he delivered the “donations” to the women. It was enough to know that he’d righted a wrong. An innocent young woman wouldn’t have to suffer more hardship because of the yahoos who’d harmed her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thinking about Faith’s vulnerability, he took a deep breath and exhaled noisily as he reentered the trading post. Near the door, the pale girl with corn-silk hair still sat atop the filled sacks. White flour dusted the back and shoulders of her blue dress, a clear reminder of her fainting spell. An older man and several women were fussing over her. Unsure of whether or not to approach, Connell paused to listen to what they were saying.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No! I can’t stay here. I just can’t,” the girl whimpered. “Please, take me back to camp with you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Now, Miss Charity,” the man was cajoling, “you’ll be perfectly safe with Mrs. Morse. Your sister might need you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No! No, no, no.” She stamped her small foot. “It wasn’t my idea to come here in the first place and I’ll not stay. I demand you deliver me back to Captain Tucker.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One of the matrons patted Charity’s hand. “There, there, dear. Of course we’ll see that you get to the captain. I’m sure your sister is in good hands.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shaking his head in disgust, Connell watched them leave before he started for the staircase.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anna Morse met him halfway up and solidly blocked his path. “Well?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The sister left,” he said, scowling.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Figures. What about the fellas what done the hurting? Did you clean their plows for ’em?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Enough to get their attention. I never did intend to start another set-to.” He transferred the money he’d collected to the proprietress. “If you want more…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No need. This’ll be plenty. I bandaged her myself. You was right. She’s got a few sore ribs.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You bound her tight?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“’Course. I did fine and so did she. She’s a spunky one, that Faith.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell nodded. “That she is.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Too bad about her ma.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They made their way to the base of the stairs, Connell in the lead. “Her ma?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Got kilt by the same twister that wiped out their house and most of their belongings,” Anna told him. “That’s why she and that worthless sister of hers are on their way to Californy to look for their pa.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Alone?” Connell couldn’t believe how many women tried to cross the plains without proper help or preparation. He didn’t fault them for their courage, only for their lack of common sense.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s right. Ramsey Tucker’s supposed to be lookin’ after them. To my thinkin’, they’d be better off all by themselves than trustin’ him.” Heading toward the busy young man who was trying to wait on three families at once, she slipped the coins Connell had collected into her apron pocket. “I’m comin’, Will.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Connell followed and asked, “When does the Tucker train pull out?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tomorrow.” Anna smiled with understanding. “Don’t fret. Our girl’ll be able to travel just fine. Now, scoot. I got work to do.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It wasn’t till Connell was outside that he remembered what Faith had said about having to drive her own team. Well and whole, she might be able to do it. Hurt the way she was, the pain would be dreadful. Besides, she might make her condition worse. Maybe even puncture a lung.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Muttering and gritting his teeth, Connell argued that Faith wasn’t his concern. Irene was. He found his horse where the boy had left it, rechecked the cinch on his saddle, then mounted. It was time to head for Maguire’s or some such place. The drink and eats he’d promised himself a whole lot earlier were way overdue.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Standing in the upstairs room in her chemise and drawers, Faith listened at the slightly open door, then quietly eased it closed. Thanks to the tight bindings around her midriff, she’d managed to get out of bed without too much discomfort. She hated corsets. Always had. But she had to admit wearing one might have spared her poor bones.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Placing her forehead and palms against the wood of the door, she closed her eyes for a moment, hoping that somehow, when she opened them again, her current predicament would prove to be no more than a bad dream.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Such was not the case. Breathing shallowly when she really wanted to sigh deeply, she straightened and took a long look at the room. The bed sagged in the middle where the ropes had stretched, but at least it was clean. Mrs. Morse had hung her soiled dress on a peg next to the pine washstand. On the floor in front of it was a small rag rug, just like the ones Grandma Reeder used to make, and laid across the foot of the bed was a plain lawn wrapper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Barefoot, Faith crossed to the bed and slowly threaded her arms into the wrapper, folding it closed. The process was painful, though not nearly as bad as she suspected trying to put on her dress would be. Pensive, she tied the sash and padded across the cool wooden floor, in search of a breeze from the open window.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The wide, busy street lay below, it’s clattering traffic an ongoing performance. Wagons of all shapes and uses were passing, as well as riders and enough foot traffic to more than fill the fondly remembered old streets of Burg Hill. In the midst of all the hubbub sat a man in buckskin astride a giant horse the color of a rusty rose.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With a trembling hand, Faith drew aside the lacy curtains and studied the traveler who had so recently borne her to safety in his arms. It was a kindness she hadn’t expected here in this wild country. She fingered her pendant and thought of home. Of family. Oh, how she wished her mother were there to be a companion in her travails, to understand her the way Charity never could.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Well, at least her Good Samaritan had the hope of someday finding his missing betrothed, Faith mused, looking down at him and stifling a tiny twinge of jealousy. She would never again see her dearest ones or the home place she’d loved, no matter how hard she wished or prayed or toiled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Suddenly realizing she had taken her deliverance for granted, Faith was penitent. Not only had she been spared the fate her poor mother had suffered, she’d been rescued a second time since then. Given the unsympathetic reactions of the other travelers she’d encountered at the fort, it was a wonderment she was not still lying in a heap in the street.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In retrospect, Faith realized she’d drifted in and out of consciousness while being carried to the trading post. She’d felt the rumble of the man’s voice beneath his buckskin shirt as he’d told the boy she’d fainted. There was also a vague recollection of a gentle hand on her face as someone touched her to brush back a lock of hair. Could that have been him?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stepping in front of half of the curtain, she toyed with the loose curls that hung down over her shoulders. Decent, grown women didn’t let anyone but their husbands see them with their hair thus, Faith reminded herself. And they certainly didn’t stand in a window clad in nothing more than their chemise and a wrapper. Yet she didn’t move away, even when the man’s head tipped back and he gazed boldly in her direction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Did he know who he was watching? He must. If not, why stare like that? There was plenty to see in the street below without bothering to peer into a tiny window fifteen feet above the entrance to the trading post.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Faith knew she should step back into the shadows. Displaying herself was indecent. Wanton. Still, there was the remembered touch of a hand on her cheek, the pounding of a strong heart beneath her ear as he bore her away in his arms, and the concern she’d glimpsed in his eyes as mental darkness had overcome her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One more look, one more thought of intense gratitude wouldn’t hurt. She knew she’d never see the man again. He had a quest of his own—the search for his bride—while she must complete her own journey. That their divergent paths had crossed at all was amazing. She only wished she’d had an opportunity to thank him in person.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wanting to memorize the image of her rescuer so she could later pay proper homage to his compassion, Faith swayed closer to the thick, white-painted casement. Beneath his beard and mustache, she thought she saw a smile, though it was impossible to be certain at such a great distance. Hopeful, she raised her hand as if bestowing a blessing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In reply, the man tipped his hat, then squared it on his head, reined his horse hard and rode off.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Faith’s heart pounded as she watched him go. Clearly, he’d entered her life to profoundly influence it. No matter how far she traveled or how many more years she lived, she’d never forget him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sudden awareness made her breath catch. Of course! The man on the red horse had been the answer to her fervent prayers for deliverance. Accepting that notion tempered her perspective of the ordeal in which she was currently embroiled. Without his amazing intervention she might actually have died, alone and ignored.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And gone to be with Jesus, she countered, certain her lonely soul would approve of the idea, just as it had ever since her mother’s fatal accident. This time, however, Faith found she was no longer looking forward to joining Mama in heaven. Yes, she wanted to see all her loved ones again someday, but her earthly tasks weren’t complete. Not yet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By proving she wasn’t truly alone in her current trials, a heaven-sent stranger had inadvertently opened her eyes—and her heart—to the possibility of a bright, worthwhile future.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And she didn’t even know his name.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9f86de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontiercourtship_ch02.vue
// module id = 72
// module chunks = 0